@use "../../variables" as *;

.icon {
  width: 1rem;
  height: 1rem;

  svg {
    width: 1rem;
    height: 1rem;
    vertical-align: baseline;
  }

  &.large {
    width: 1.5rem;
    height: 1.5rem;

    svg {
      width: 1.5rem;
      height: 1.5rem;
    }
  }

  &.crossedOutWheeledBin {
    width: 2rem;
    height: 2rem;

    svg {
      width: 2rem;
      height: 2rem;
    }
  }
}

/* Solid icons get a fill */
.solid {
  fill: #888888;
  stroke: none
}

.exclamation {
  fill: $blue-info;

  svg {
    width: 1.75rem;
    height: 1.75rem;
  }
}

.check {
  fill: #6FA558;
}

.warning {
  fill: #EFCA13;
}